// src/contexts/ThemeContext.js
import { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext(null);

const STORAGE_KEY = 'cettomate_theme';

function applyLightTheme() {
  document.documentElement.setAttribute('data-theme', 'light');
  document.documentElement.style.colorScheme = 'light';
  try {
    window.localStorage.setItem(STORAGE_KEY, 'light');
  } catch (error) {
    console.error('Failed to save theme preference:', error);
  }
}

export function ThemeProvider({ children }) {
  const [theme] = useState('light');

  useEffect(() => {
    applyLightTheme();

    // Stay on light even when the OS switches to dark mode
    const darkModeQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleSystemThemeChange = () => applyLightTheme();

    darkModeQuery.addEventListener('change', handleSystemThemeChange);
    return () => darkModeQuery.removeEventListener('change', handleSystemThemeChange);
  }, []);

  const toggleTheme = () => {
    applyLightTheme();
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return {
    theme: context.theme,
    toggleTheme: context.toggleTheme,
    isDark: context.theme === 'dark',
    isLight: context.theme === 'light',
  };
}

